import { lazyWithPreload as lazy } from 'react-lazy-with-preload';

export const PersonalDetails = {
  Content: lazy(
    () =>
      import(
        'components/direct-sales/personal-details/components/PersonalDetailsContent'
      )
  ),
  RightSidebar: lazy(
    () =>
      import(
        'components/direct-sales/personal-details/components/PersonalDetailsSidebarRight'
      )
  ),
  Header: lazy(
    () =>
      import(
        'components/direct-sales/personal-details/components/PersonalDetailsHeader'
      )
  )
};

export default PersonalDetails;
